<template>
<div>
  <div v-if="isMobile">
    <mobile-hui></mobile-hui>
  </div>
  <div v-else>
    <div class="hui-content" v-if="page === 1">
      <div class="banner">
        <img :src="bannerUrl" alt="">
      </div>
      <div class="subitem bgColor"><span class="textColor">新界活动</span></div>
      <div class="list">
        <div class="box">
          <ul>
            <li @click="goDetail(item)" v-for="(item, index) in list" :key="index" class="wow zoomIn pointer" style="visibility: visible; animation-name: zoomIn;">
              <a>
                <div class="pic">
                  <img :src="item.image" alt="" class="trans-img">
                </div>
                <div class="title elli bgTextColor">
                  {{item.title}}<span>{{String(item.release_time_text).slice(0, 10)}}</span>
                </div>
                <!-- <div class="jj bgTextColor">{{item.subtitle}}</div> -->
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="pager">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          v-model:current-page="currentPage"
          :page-size="limit"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 显示详情 -->
    <div v-if="page === 2">
      <news-detail :id="detailID" @back="page = 1"></news-detail>
    </div>
  </div>
</div>
</template>

<script>
import { getBannerById, getListByTypeId } from '../api/api.js'
import { ElMessage } from 'element-plus'
import { baseURL } from '../utils/const.js'
import newsDetail from 'views/about/newsDetail.vue'
import MobileHui from './mobile/hui.vue'

export default {
  components: { newsDetail, MobileHui },
  data () {
    return {
      isMobile: false,
      bannerUrl:'',
      baseURL,
      detailID: '',
      page: 1,
      total: 0,
      currentPage: 1,
      limit: 8,
      list: []
    }
  },
  mounted () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) { // 手机端
      this.isMobile = true
      return;
    }
    new this.$wow.WOW().init()
    this.getBannerById(8)
    this.getList()
  },
  methods: {
    goDetail (item) {
      //如果是站外打开
      if(item.open_type==2){
        window.open(item.uri)
        return
      }
      this.page = 2
      this.detailID = item.id
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    async getList () {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        type_id: 2
      }
      try {
        const res = await getListByTypeId(params)
        this.total = res.data.total
        this.list = res.data.data
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    async getBannerById (id) {
      try {
        const res = await getBannerById(id)
        this.bannerUrl = res.data[0].image
        console.log(this.bannerUrl)
      } catch (err) {
        ElMessage.error(err.message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.hui-content {
  .banner {
    width: 100%;
    height: 410px;
    img {
      width: 100%;
      height: 100%;
      background-size: cover;
    }
  }
  .subitem {
    padding: 49px 0 43px 0;
    text-align: center;
    span {
      display: inline-block;
      vertical-align: top;
      margin: 0 29px;
      border-bottom: 2px solid #e5006e;
    }
  }
  .list {
    padding: 20px 0 80px 0;
    overflow: hidden;
    box-sizing: border-box;
    .box {
      margin: 0px;
      padding: 0 5%;
      ul {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;
        box-sizing: border-box;
        overflow: hidden;
        li {
          width: 40%;
          float: left;
          margin-top: 60px;
          padding: 0 22px;
          float: left;
          a {
            display: block;
            position: relative;
            padding-right: 30px;
            .pic {
              width: 100%;
              float: left;
              position: relative;
              padding-bottom: 56.16%;
              img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                -webkit-transition: all 0.5s ease-out 0s;
                -moz-transition: all 0.5s ease-out 0s;
                -o-transition: all 0.5s ease-out 0s;
                transition: all 0.5s ease-out 0s;
              }
            }
            .pic:before {
              content: '';
              width: 100%;
              height: 100%;
              position: absolute;
              z-index: 1;
              right: -30px;
              bottom: -88px;
              background: #f4f1e7;
              -webkit-transition: all 0.5s ease-out 0s;
              -moz-transition: all 0.5s ease-out 0s;
              -o-transition: all 0.5s ease-out 0s;
              transition: all 0.5s ease-out 0s;
            }
            .title {
              width: 100%;
              position: relative;
              padding: 0 85px 0 61px;
              font-size: 16px;
              line-height: 88px;
              z-index: 2;
              -webkit-transition: all 0.5s ease-out 0s;
              -moz-transition: all 0.5s ease-out 0s;
              -o-transition: all 0.5s ease-out 0s;
              transition: all 0.5s ease-out 0s;
              span {
                position: absolute;
                right: 0;
                top: 0;
                font-size: 16px;
              }
            }
            .elli {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .jj {
              width: 100%;
              float: left;
              position: relative;
              height: 60px;
              overflow: hidden;
              margin-top: 15px;
              padding: 0 0 0 61px;
              font-size: 16px;
              line-height: 30px;
              z-index: 2;
            }
          }
        }
      }
    }
  }
  .pager {
    margin: 40px auto;
    text-align: center;
  }
}
</style>
